import React, { Component, Fragment } from 'react'
import DateRangePicker from './DatePicker.jsx';
import './date-selector.scss';
import 'bootstrap-daterangepicker/daterangepicker.css'
import zh_cn from './zh-cn'
import moment from 'moment'

export default  class DateSelector extends Component {

  constructor(){
    super();
    this.state = {
      checked: 0,
      type:1,
    }
  }

  onApply(picker){
    var start = picker.startDate.format(this.props.format || 'YYYY-MM-DD HH:mm');
    var end = picker.endDate.format(this.props.format || 'YYYY-MM-DD HH:mm');
    this.props.cb({start, end});
  }

  onShotDate(days){
    this.setState({checked: days});
    var start = $.momentDate().startOf('days').add(days, 'days').format(this.props.format || 'YYYY-MM-DD HH:mm');
    var end = $.momentDate().endOf('days').format(this.props.format || 'YYYY-MM-DD HH:mm');
    this.props.cb({start, end});
  }
  setType(type){
    this.setState({
      type:type
    })
    this.props.setIschinld(type)
  }
  setUsername(e){
    this.props.setUsername(e.target.value)
  }
  onShow(){
    _.each(document.querySelectorAll('.daterangepicker button.cancelBtn'), item => {
      item.innerHTML = '取消';
    })
    _.each(document.querySelectorAll('.daterangepicker button.applyBtn'), item => {
      item.innerHTML = '确定';
    })
  }

  render() {
    return (
      <div className={this.props.className || 'dateSelector-box'}>
        <span className='fl'>时间范围：</span>
        <DateRangePicker
           timePicker={this.props.format == 'YYYY-MM-DD' ? false : true}
           timePicker24Hour={this.props.format == 'YYYY-MM-DD' ? false : true}
           autoApply
           startDate={this.props.start}
           endDate={this.props.end}
           locale={zh_cn}
           onApply={(e, picker) => this.onApply(picker)}
           onShow={() => this.onShow()}
           maxDate={this.props.maxDate || $.momentDate().endOf('day')}
           maxSpan={moment.duration({days: this.props.maxSpan || 365})}
           minDate={this.props.minDate || '1970-01-01'}
         >
          <input type="text" value={`${this.props.start} ~ ${this.props.end}`} style={{width: this.props.format == 'YYYY-MM-DD' ? '160px' : '230px'}} disabled />
        </DateRangePicker>
        <div className='shortcut'>
          {
            this.props.fastSelect &&
            <Fragment>
              <span className={this.state.checked == 0 ? 'checked' : ''} onClick={() => this.onShotDate(0)} >今日</span>
              <span className={this.state.checked == -2 ? 'checked' : ''} onClick={() => this.onShotDate(-2)} >近三日</span>
              <span className={this.state.checked == -6 ? 'checked' : ''} onClick={() => this.onShotDate(-6)} >近七日</span>
            </Fragment>
          }
          {
            this.props.layout_2 &&
            <Fragment>
              <p className={'query-username'}>
                <div>用户名:</div>
                <input onChange={this.setUsername.bind(this)} type="text"/>
              </p>
              <button className={this.state.type == '0' ? 'query-ischild active' : 'query-ischild'} onClick={() => this.setType(0)}>个人</button>
              <button className={this.state.type == '1' ? 'query-ischild active' : 'query-ischild'} onClick={() => this.setType(1)}>团队</button>
            </Fragment>
          }
          <span className='query' onClick={()=>this.props.action()}>查询</span>
        </div>
      </div>
    )
  }
}
